import { render, staticRenderFns } from "./Erro.vue?vue&type=template&id=00f82cc7&lang=pug"
import script from "./Erro.vue?vue&type=script&lang=js"
export * from "./Erro.vue?vue&type=script&lang=js"
import style0 from "./Erro.vue?vue&type=style&index=0&id=00f82cc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports